import React from "react";
import { Helmet } from "react-helmet-async";
import { MapPin, Coffee } from "lucide-react";
import { Section, SectionTitle, Reveal } from "../components/UIBits";
import { TOURNAMENT } from "../lib/constants";
import { useT } from "../lib/i18n";

export default function InfoPage() {
    const { t } = useT();
    return (
        <div data-testid="info-page">
            <Helmet><title>{`${t("info.title_pre")} ${t("info.title_accent")} — ${TOURNAMENT.name}`}</title></Helmet>
            <Section>
                <SectionTitle kicker={t("info.kicker")} title={t("info.title_pre")} accent={t("info.title_accent")} />
                <div className="grid md:grid-cols-2 gap-6">
                    <Reveal><div className="glass-card p-6">
                        <MapPin className="text-[#7FD93C] mb-3" />
                        <h3 className="font-display text-2xl uppercase mb-2">{t("info.site_title")}</h3>
                        <p className="text-white/70">{TOURNAMENT.arena}<br />{TOURNAMENT.address}<br /><span className="text-xs text-white/40 mt-2 block">{t("info.site_surfaces")}</span></p>
                    </div></Reveal>
                    <Reveal delay={0.1}><div className="glass-card p-6">
                        <Coffee className="text-[#7FD93C] mb-3" />
                        <h3 className="font-display text-2xl uppercase mb-2">{t("info.food_title")}</h3>
                        <p className="text-white/70">{t("info.food_body")}</p>
                    </div></Reveal>
                </div>
            </Section>
        </div>
    );
}
